import { AnswerMode } from "models/AiResearch";

export const setTalkMode = (talkId: string, mode: AnswerMode) => ({
  type: "aiResearch/SET_TALK_MODE" as const,
  payload: { talkId, mode }
});

export const removeTalkMode = (talkId: string) => ({
  type: "aiResearch/REMOVE_TALK_MODE" as const,
  payload: talkId
});

export const clearAiResearch = () => ({
  type: "aiResearch/CLEAR_STATE" as const
});

export type AiResearchActions = ReturnType<
  typeof setTalkMode | typeof removeTalkMode | typeof clearAiResearch
>;
